import TestItemOngoingHorizontal from './test-item-ongoing-horizontal';

export default TestItemOngoingHorizontal;


// WEBPACK FOOTER //
// ./src/modules/test/components/TestItemOngoingHorizontal/index.js